import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import {
  IconCollection,
  IconProfileCard,
  LayoutSingleColumn,
  Modal,
  Page,
  Skeleton,
  GoBackButton,
} from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import css from './RuleBooksSearchPage.module.css';
import { isScrollingDisabled, manageDisableScrolling } from '../../ducks/ui.duck';
import RuleBooksCards from './RuleBooksCards/RuleBooksCards';
import { addOrRemoveFavChats } from './RuleBooksSearchPage.duck';
import { FormattedMessage, useIntl } from 'react-intl';
import Slider from 'react-slick';
import classNames from 'classnames';

import {
  communityPostAccess,
  createTicketEventIDs,
  EXPLORE,
  NOTIFICATION,
  REQUEST_RULEBOOK_TEMPLATE_ID,
  SIGNUP_TAB_DETAIL,
} from '../../util/types';
import { useHistory } from 'react-router-dom';
import { createResourceLocatorString } from '../../util/routes';
import PaginationMyActivity from '../CircleCommunityPage/components/MyActivity/PaginationMyActivity';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import ChatBotSideBar from '../AiChatBotPage/ChatBotSideBar/ChatBotSideBar';
import RequestRuleBookForm from '../PageBuilder/SectionBuilder/SectionHero/RequestRuleBookForm';
import { onCreateIntercomTicket, onSingleMailApiCollection } from '../../util/api';
import { checkElephantModalOpen, currentUserRole, getUserPermissions } from '../../util/data';
import { setElephantVerificationModal, subscriptionPermissionRequest } from '../../ducks/user.duck';
import CreatePostBar from '../CircleCommunityPage/components/CreatePostBar/CreatePostBar';
import NotificationMobileModal from '../../components/NotificationDropdown/NotificationMobileModal';
import {
  advancedSearch,
  createSpacePost,
  getNotificationPreference,
  getNotificationsList,
  markAllNotificationsAsRead,
  markNotificationAsRead,
  toggleCreatePost,
  updateNotificationPreference,
} from '../CircleCommunityPage/CircleCommunityPage.duck';
import SideBar from './FeedTabs/SideBar/SideBar';
import { ReactToastify, toastifyFn } from '../../components/ReactToastify/ReactToastify';
import { parse } from '../../util/urlHelpers';
import { openIntecomOnClickEvents } from '../../components/IntercomComponent/IntercomComponent';
import MobileBottomTabs from '../CircleCommunityPage/components/MobileBottomTabs/MobileBottomTabs';

const RuleBooksSearchPage = props => {
  const history = useHistory();
  const intl = useIntl();
  const routeConfiguration = useRouteConfiguration();
  const [searchValue, setSearchValue] = useState(() => {
    const parsed = parse(history.location.search);
    return parsed.rulebook || '';
  });

  const [isSideBarOpen, setIsSideBarOpen] = useState(false);
  const [requestRuleBookModal, setRequestRuleBook] = useState({
    isModalOpen: false,
    inProgress: false,
  });
  const [isOpen, setIsOpen] = useState(false);
  const favouritesRef = useRef(null);

  const {
    currentUser,
    scrollingDisabled,
    fetchAllGptsInProgress,
    gptsDetails,
    fetchAllGptsError,
    userFavChatDetails,
    chatDetails,
    fetchChatInProgress,
    fetchChatError,
    onManageDisableScrolling,
    onToggleCreatePost,
    onFetchNotifications,
    requestNotificationsInProgress,
    notificationsData,
    requestNotificationPreferenceInProgress,
    notificaitonPreferenceData,
    onMarkNotificationRead,
    onGetNotificationPreference,
    onUpdateNotificationPreference,
    onMarkAllNotificationsAsRead,
    isCreatePost,
    requestDirectUpload,
    currentCommunityMember,
    spaceListData,
    advancedSearchData,
    onSubscriptionPermissionRequest,
    onAdvancedSearch,
    params,
    onCreateSpacePost,
    onSetElephantVerificationModal,
    ...rest
  } = props;

  const isOpenElephantModal = checkElephantModalOpen(currentUser);

  const userSubscriptionRole = currentUserRole(currentUser);
  const checkCreatePostAuth = getUserPermissions(userSubscriptionRole, communityPostAccess);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (params?.rulebookId === 'favourites' && favouritesRef.current) {
        window.scrollTo({
          top: favouritesRef.current.offsetTop - 100, // Adjust the offset value to make the position more top
          behavior: 'smooth',
        });
      }
    }, 1000);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [params?.rulebookId, fetchChatInProgress]);

  const handleIconClick = content => {
    const { tab, pageName, params } = content;

    if (tab === 'MENU') {
      setIsSideBarOpen(tab);
    } else if (tab === 'ADD_MENU') {
      if (isOpenElephantModal && !isCreatePost) {
        onSetElephantVerificationModal(true);
        return;
      }

      if (!checkCreatePostAuth) {
        onSubscriptionPermissionRequest(true);
        return;
      }
      onToggleCreatePost(true);
    } else if (tab == 'SUPPORT') {
      openIntecomOnClickEvents();
      return;
    } else {
      return (
        pageName &&
        history.push(createResourceLocatorString(pageName, routeConfiguration, params, {}))
      );
    }

    // else if (tab === EXPLORE) {
    //   window.location.href = '/feed-page/group-search';
    // } else if (tab === NOTIFICATION) {
    //   setIsOpen(true);
    // }
  };

  const closeSideBar = () => {
    setIsSideBarOpen(false);
  };

  const scrollToSection = e => {
    e.preventDefault();
    e.stopPropagation();
    if (currentUser?.id?.uuid) {
      if (!currentUser?.attributes?.emailVerified) {
        return history.push(
          createResourceLocatorString(
            'SignUpStepsPage',
            routeConfiguration,
            { tab: SIGNUP_TAB_DETAIL },
            {}
          )
        );
      }
      setRequestRuleBook({
        ...requestRuleBookModal,
        isModalOpen: true,
      });
    }
  };
  const mobileBottomTabsComponent = (
    <MobileBottomTabs
      currentUser={currentUser}
      handleIconClick={handleIconClick}
      selectedTab={'TURNOUTAI'}
    />
  );


  var settings = {
    dots: false,
    infinite: false,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  };

  const { favGpt = [], gpts = [] } = userFavChatDetails || {};

  const recentFileIds = chatDetails?.map(chat => chat.rulebook_id);
  const recentGpts = gpts?.filter(e => recentFileIds?.includes(e.rulebook_id)) || [];

  // Get the last file_id from fileIdsArray
  const lastFileId =
    Array.isArray(recentFileIds) && recentFileIds.length
      ? recentFileIds[recentFileIds?.length - 1]
      : '';

  // Sort filesArray so that items with lastFileId appear first
  const recentChats = recentGpts?.sort((a, b) => {
    return (b.file_id == lastFileId ? 1 : 0) - (a.rulebook_id == lastFileId ? 1 : 0);
  });

  const favFileIds = favGpt?.map(chat => chat.rulebook_id) || [];
  const favChats = gpts?.filter(e => favFileIds?.includes(e.rulebook_id)) || [];
  const GPTS = (gptsDetails && gptsDetails.gpts) || [];
  const { currentPage, pageSize, totalPages, totalRecords } = gptsDetails || {};

  const onSubmit = async (values, form) => {
    setRequestRuleBook(prevState => ({ ...prevState, inProgress: true }));

    try {
      const { email, profile } = currentUser?.attributes || {};
      const { firstName = '', lastName = '' } = profile || {};

      // const data = {
      //   ...values,
      //   userName: `${firstName} ${lastName}`,
      //   userEmail: email,
      //   email: process.env.REACT_APP_SENDGRID_ADMIN_RECIVER_EMAIL,
      //   name: process.env.REACT_APP_SENDGRID_SENDER_NAME,
      //   userId: currentUser?.id?.uuid,
      //   groupName: values.rulebook,
      //   viewRequestURL: ""
      // };

      const createTicketData = {
        ticketTypeId: createTicketEventIDs['Rulebook Request'],
        attributes: {
          name: firstName + ' ' + lastName,
          userEmail: email,
          userId: currentUser?.id?.uuid,
          rulebookName: values?.rulebookName || '',
          rulebookLink: values?.rulebookLink || '',
          description: values?.admin || '',
        },
        assignment: true,
      };

      await onCreateIntercomTicket(createTicketData);

      // await onSingleMailApiCollection({
      //   data,
      //   template_id: REQUEST_RULEBOOK_TEMPLATE_ID,
      // });

      toastifyFn('success', intl.formatMessage({ id: 'RequestRulebookForm.submitSuccess' }));
    } catch (error) {
      console.error('Error submitting request rulebook:', error);
      toastifyFn('error', intl.formatMessage({ id: 'RequestRulebookForm.submitError' }));
    } finally {
      setRequestRuleBook({ isModalOpen: false, inProgress: false });
    }
  };

  const NotificationMobileComponent = (
    <NotificationMobileModal
      onFetchNotifications={onFetchNotifications}
      requestNotificationsInProgress={requestNotificationsInProgress}
      notificationsData={notificationsData}
      isOpen={isOpen}
      setIsOpen={() => setIsOpen(false)}
      onMarkNotificationRead={onMarkNotificationRead}
      onManageDisableScrolling={onManageDisableScrolling}
      requestNotificationPreferenceInProgress={requestNotificationPreferenceInProgress}
      notificaitonPreferenceData={notificaitonPreferenceData}
      onGetNotificationPreference={onGetNotificationPreference}
      onUpdateNotificationPreference={onUpdateNotificationPreference}
      onMarkAllNotificationsAsRead={onMarkAllNotificationsAsRead}
      currentUser={currentUser}
    />
  );

  const handlePostCreation = async (apiParams, spaceId, postId) => {
    const response = await onCreateSpacePost(apiParams, spaceId, postId);
    if (response?.id) {
      return history.push(
        createResourceLocatorString('PostViewPage', routeConfiguration, {
          spaceId,
          slug: response?.slug,
          postId: response?.id,
        })
      );
    }
  };

  return (
    <Page scrollingDisabled={scrollingDisabled} className={css.pageRoot}>
      <LayoutSingleColumn
        className={css.pageWrapper}
        topbar={
          <>
            <TopbarContainer
              desktopClassName={css.desktopTopbar}
              mobileClassName={css.mobileTopbar}
              currentPage="RuleBooksSearchPage"
            />
            {/* {params?.rulebookId && params.rulebookId !== 'all' && params.rulebookId !== 'favourites' && <GoBackButton desktopOnly />} */}
          </>
        }
      >
        <div className={css.container}>
          <div className={classNames(css.sidebar, isSideBarOpen && css.sidebarOpen)}>
            <ChatBotSideBar
              currentPage={'AiChatBotPage'}
              gptsDetails={gptsDetails}
              fetchChatInProgress={fetchChatInProgress}
              chatDetails={chatDetails}
              fetchChatError={fetchChatError}
              isSideBarOpen={isSideBarOpen}
              userFavChatDetails={userFavChatDetails}
              scrollToSection={scrollToSection}
              params={params}
              currentUser={currentUser}
            />
          </div>

          <div className={css.chatSection}>
            {currentPage == 1 ? (
              <>
                <div>
                  <div className={css.headerContainer}>
                    {currentUser && currentUser?.id?.uuid ? (
                      <h4 className={css.title}>
                        <FormattedMessage id="RuleBooksSearchPage.recentHeading" />
                      </h4>
                    ) : null}
                    <div className={css.searchContainer}>
                      <span
                        className={css.icon}
                        onClick={() => {
                          if (searchValue) {
                            history.push(
                              createResourceLocatorString(
                                'RuleBooksSearchPage',
                                routeConfiguration,
                                { rulebookId: 'recent' },
                                { rulebook: searchValue }
                              )
                            );
                          }
                        }}
                      >
                        <IconCollection name="iconSearch" />
                      </span>
                      <input
                        type="text"
                        placeholder="Search by rulebook"
                        onChange={e => setSearchValue(e.target.value)}
                        value={searchValue}
                        onKeyDown={e => {
                          if (e.key === 'Enter') {
                            history.push(
                              createResourceLocatorString(
                                'RuleBooksSearchPage',
                                routeConfiguration,
                                { rulebookId: 'all' },
                                { rulebook: searchValue }
                              )
                            );
                          }
                        }}
                      />
                    </div>
                  </div>
                  {currentUser && currentUser?.id?.uuid ? (
                    <>
                      {recentChats && recentChats?.length > 0 ? (
                        <div className={css.cardWrapper}>
                          <Slider {...settings}>
                            {recentChats?.map((rulebooks, index) => (
                              <div style={{ width: 387 }} key={index}>
                                <RuleBooksCards
                                  {...rest}
                                  currentUser={currentUser}
                                  rulebooks={rulebooks}
                                  favFileIds={favFileIds}
                                  history={history}
                                  routeConfiguration={routeConfiguration}
                                />
                              </div>
                            ))}
                          </Slider>
                        </div>
                      ) : fetchChatInProgress ? (
                        <div className={css.noResultFound}>
                          {' '}
                          <Skeleton AiChatBot={true} height={387} width={320} />
                        </div>
                      ) : fetchChatError ? (
                        <div className={css.noResultFound}>
                          <FormattedMessage id="RuleBooksSearchPage.failedToLoad" />
                        </div>
                      ) : (
                        <div className={css.noResultFound}>
                          <FormattedMessage id="RuleBooksSearchPage.noResultFound" />
                        </div>
                      )}
                    </>
                  ) : null}
                </div>

                {currentUser && currentUser?.id?.uuid ? (
                  <div id="favourites" ref={favouritesRef}>
                    <h4 className={css.title}>
                      <FormattedMessage id="RuleBooksSearchPage.favHeading" />
                    </h4>
                    {favChats && favChats.length > 0 ? (
                      <div className={css.cardWrapper}>
                        <Slider {...settings}>
                          {favChats?.map((rulebooks, index) => {
                            return (
                              <div style={{ width: 387 }}>
                                <RuleBooksCards
                                  key={index}
                                  {...rest}
                                  currentUser={currentUser}
                                  rulebooks={rulebooks}
                                  favFileIds={favFileIds}
                                  history={history}
                                  routeConfiguration={routeConfiguration}
                                />
                              </div>
                            );
                          })}
                        </Slider>
                      </div>
                    ) : fetchChatInProgress ? (
                      <div className={css.noResultFound}>
                        {' '}
                        <Skeleton AiChatBot={true} height={387} width={320} />
                      </div>
                    ) : fetchChatError ? (
                      <div className={css.noResultFound}>
                        <FormattedMessage id="RuleBooksSearchPage.failedToLoad" />
                      </div>
                    ) : (
                      <div className={css.noResultFound}>
                        <FormattedMessage id="RuleBooksSearchPage.noFavResultFound" />
                      </div>
                    )}
                  </div>
                ) : null}
              </>
            ) : null}

            <div>
              <h4 className={css.title}>
                <FormattedMessage id="RuleBooksSearchPage.allChatHeading" />
              </h4>
              {GPTS && GPTS.length > 0 ? (
                <div className={css.cardGridWrapper}>
                  {GPTS?.map((rulebooks, index) => {
                    return (
                      <>
                        <RuleBooksCards
                          key={index}
                          {...rest}
                          currentUser={currentUser}
                          rulebooks={rulebooks}
                          favFileIds={favFileIds}
                          history={history}
                          routeConfiguration={routeConfiguration}
                        />
                      </>
                    );
                  })}
                </div>
              ) : fetchAllGptsInProgress ? (
                <div className={css.noResultFound}>
                  {' '}
                  <Skeleton AiChatBot={true} height={387} width={320} />
                </div>
              ) : fetchChatError ? (
                <div className={css.noResultFound}>
                  <FormattedMessage id="RuleBooksSearchPage.failedToLoad" />
                </div>
              ) : (
                <div className={css.noResultFound}>
                  <FormattedMessage id="RuleBooksSearchPage.noResultFound" />
                </div>
              )}
            </div>
            {totalPages > 1 ? (
              <div className={css.paginationContainer}>
                <PaginationMyActivity
                  currentPage={currentPage}
                  hasNextPage={currentPage < totalPages}
                  onPageChange={page => {
                    history.push(
                      createResourceLocatorString(
                        'RuleBooksSearchPage',
                        routeConfiguration,
                        { rulebookId: String(params?.rulebookId) },
                        {
                          page,
                          ...(searchValue ? { rulebook: searchValue } : {}),
                        }
                      )
                    );
                  }}
                  posts_count={totalRecords}
                  per_page={pageSize}
                  isActiveTab={'documents'}
                />
              </div>
            ) : null}
            <ReactToastify />
          </div>
        </div>
        {currentUser && currentUser?.id ? mobileBottomTabsComponent : null}
        <SideBar
          isOpen={isSideBarOpen}
          onClose={closeSideBar}
          currentPage={'AiChatBotPage'}
          gptsDetails={gptsDetails}
          fetchChatInProgress={fetchChatInProgress}
          chatDetails={chatDetails}
          fetchChatError={fetchChatError}
          isSideBarOpen={isSideBarOpen}
          userFavChatDetails={userFavChatDetails}
          scrollToSection={scrollToSection}
          favChats={favChats}
          currentUser={currentUser}
        />

        <Modal
          id="RequestRulebookModal.SectionHero"
          isOpen={requestRuleBookModal.isModalOpen}
          onClose={() =>
            setRequestRuleBook({
              isModalOpen: false,
              inProgress: false,
              isError: null,
            })
          }
          onManageDisableScrolling={onManageDisableScrolling}
          className={css.mobileNotificationModal}
        >
          <div>
            <div className={css.headingWrapper}>
              <h1>{intl.formatMessage({ id: 'RequestRulebookModal.requestRulebook' })}</h1>

              <div className={css.subHeading}>
                {/* <IconProfileCard type='info' /> */}
                {/* {intl.formatMessage(
                  { id: 'RequestRulebookModal.requestRulebookSub' }
                )} */}
                Let the TurnoutHQ admins know about your rulebook!
              </div>
            </div>

            <RequestRuleBookForm
              onSubmit={(values, form) => onSubmit(values, form)}
              inAddUpdateProgress={requestRuleBookModal.inProgress}
              intl={intl}
            />
          </div>
        </Modal>
        {NotificationMobileComponent}

        {isCreatePost ? (
          <div>
            <CreatePostBar
              requestDirectUpload={requestDirectUpload}
              currentCommunityMember={currentCommunityMember}
              spaceListData={spaceListData}
              onCreateSpacePost={handlePostCreation}
              isCreatePost={isCreatePost}
              onToggleCreatePost={value => {
                if (isOpenElephantModal && !isCreatePost) {
                  onSetElephantVerificationModal(true);
                  return;
                }

                checkCreatePostAuth
                  ? onToggleCreatePost(value)
                  : onSubscriptionPermissionRequest(true);
              }}
              onAdvancedSearch={onAdvancedSearch}
              advancedSearchData={advancedSearchData}
              params={params}
              currentUser={currentUser}
            />
          </div>
        ) : null}
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  const {
    fetchAllGptsInProgress,
    gptsDetails,
    fetchAllGptsError,
    userFavChatDetails,
    chatDetails,
    fetchChatInProgress,
    fetchChatError,
  } = state.RuleBooksSearchPage;
  const { currentUser } = state.user;
  const {
    requestNotificationsInProgress,
    notificationsData,
    requestNotificationPreferenceInProgress,
    notificaitonPreferenceData,
    isCreatePost,
    requestDirectUpload,
    currentCommunityMember,
    spaceListData,
    advancedSearchData,
  } = state.CircleCommunityPage;
  return {
    currentUser,
    scrollingDisabled: isScrollingDisabled(state),
    fetchAllGptsInProgress,
    gptsDetails,
    fetchAllGptsError,
    userFavChatDetails,
    chatDetails,
    fetchChatInProgress,
    fetchChatError,
    requestNotificationsInProgress,
    notificationsData,
    requestNotificationPreferenceInProgress,
    notificaitonPreferenceData,
    isCreatePost,
    requestDirectUpload,
    currentCommunityMember,
    spaceListData,
    advancedSearchData,
  };
};
const mapDispatchToProps = dispatch => ({
  onAddOrRemoveFavChats: params => dispatch(addOrRemoveFavChats(params)),
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  onToggleCreatePost: value => dispatch(toggleCreatePost(value)),
  onFetchNotifications: () => dispatch(getNotificationsList()),
  onMarkNotificationRead: id => dispatch(markNotificationAsRead(id)),
  onGetNotificationPreference: () => dispatch(getNotificationPreference()),
  onUpdateNotificationPreference: params => dispatch(updateNotificationPreference(params)),
  onMarkAllNotificationsAsRead: () => dispatch(markAllNotificationsAsRead()),
  onCreateSpacePost: (apiParams, spaceId) => dispatch(createSpacePost(apiParams, spaceId)),
  onSubscriptionPermissionRequest: type => dispatch(subscriptionPermissionRequest(type)),
  onAdvancedSearch: params => dispatch(advancedSearch(params)),
  onSetElephantVerificationModal: params => dispatch(setElephantVerificationModal(params)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(RuleBooksSearchPage);
